import {
	AboutUsRoute,
	BecomeAPartnerRoute,
	GiveawaysRoute,
	HomeRoute,
	MerchCartRoute,
	MerchRoute,
	WinnersRoute,
} from "@/features/home/route";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useSiteSettings } from "../providers/site-settings";

function NavigationButton({
	title,
	url,
	bold = false,
	right,
}: {
	title: string;
	url: string | string[];
	bold?: boolean;
	right?: React.ReactNode;
}) {
	const location = useLocation();
	const locationPath = location.pathname;
	const { settings } = useSiteSettings();
	const storeEnabled = settings.storeEnabled;

	const urlArray = Array.isArray(url) ? url : [url];

	const isActive = urlArray.some((route) => {
		// Avoid highlighting Store when the user is specifically on the Cart page.
		if (route === MerchRoute && locationPath.startsWith(MerchCartRoute)) {
			return false;
		}

		return locationPath === route || locationPath.startsWith(`${route}/`);
	});
	const heroRoutes = [
		HomeRoute,
		AboutUsRoute,
		WinnersRoute,
		BecomeAPartnerRoute,
		GiveawaysRoute,
	];
	const isStoreIndex =
		locationPath === MerchRoute || locationPath === `${MerchRoute}/`;
	const isStoreHero = isStoreIndex && storeEnabled;
	// Most pages use the blue hero header (white nav). Store listing only uses the hero
	// when the feature is enabled; otherwise it shows a white "unavailable" state.
	const onWhiteBackground = !(heroRoutes.includes(locationPath) || isStoreHero);

	const textClass = bold ? "web-button" : "web-body-b2";
	const colorClass = onWhiteBackground ? "text-black" : "text-white";
	const textClasses = `${textClass} ${colorClass} flex gap-2 items-center`;

	const firstUrl = Array.isArray(url) ? url[0] : url;
	const underline = onWhiteBackground ? "bg-blue-700" : "bg-white";

	return firstUrl ? (
		<div className="flex flex-col items-center">
			<Link className={textClasses} to={firstUrl}>
				{title}
				{right}
			</Link>
			<div
				className={`rounded-1 mt-2 h-1 w-8 ${isActive ? underline : ""}`}
			></div>
		</div>
	) : (
		<p className={textClasses}>{title}</p>
	);
}

export default NavigationButton;
